import { useParams } from "react-router-dom"
import { MentorGroupMembershipSettingsContainer } from "../members/list/MentorGroupMembershipSettingsCard"

function GroupMemberMembershipAugmentation({ groupId }: { groupId: number }) {
  const { manageMember } = useParams<{
    manageMember: string
  }>()

  return (
    <MentorGroupMembershipSettingsContainer
      membershipId={parseInt(manageMember?.match(/\d+/)?.[0]!)}
      groupId={groupId}
    />
  )
}

export default GroupMemberMembershipAugmentation
